<section class="cat-content">
    <div class="container">
        <div class="row" style="direction: ltr;">
            <div class="col-md-4" *ngFor="let c of categories" style="margin-bottom: 20px;">
                <div class="shape d-flex align-center text-center">
                    <div class="shape-content w-100">
                        <img [src]="c.img" style="width: 100px; margin-bottom: 15px;" />
                        <h6 style="font-weight: bold;">{{c.title}}</h6>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>